import {featureCollection} from '@turf/turf';

import {getBoundsFromFeature} from '@components/Common/Mapbox/utils/mapbox-utils';

import horizonJSON from '@utils/json';

export function formExposureBoundAndDataSource(alertDetails) {
  const {id, fullTitle, gist, severity: {key: severityKey} = {}, mapData: {exposureGeoJson} = {}} = alertDetails;

  let featureGeometry = horizonJSON.parse(exposureGeoJson);

  const dataSource = featureCollection([
    {
      properties: {
        'feature-impact': 'Extreme',
        'feature-id': id,
        'feature-title': fullTitle,
        'feature-description': gist,
        severity: severityKey,
      },
      geometry: featureGeometry,
    },
  ]);

  const bounds = featureGeometry
    ? getBoundsFromFeature(dataSource)
    : [
        [0, 0],
        [0, 0],
      ];

  return {bounds, dataSource};
}
